import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_back",
  "use": "svg_back-usage",
  "viewBox": "0 0 8 12",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 8 12\" id=\"svg_back\"><path d=\"M5.833 11.5.333 6l5.5-5.5 1.39 1.389-4.056 4.055L7.222 10l-1.389 1.5Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol